import Vue from 'vue';
import './plugins/vuetify';
import VueRouter from 'vue-router';
import localforage from 'localforage';
import App from './App.vue';
import store from './store/store';
import routes from './routes';
import vuetify from './plugins/vuetify';
import './registerServiceWorker'

//Ignore this error
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

Vue.config.productionTip = false;
localforage.config({
  name: 'qclassDB',
  version: 1,
  storeName: 'aluno',
});

Vue.use(localforage);
Vue.use(VueRouter);

const router = new VueRouter({ mode: 'history', routes });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
